<ng-container *transloco="let t">
  <div
    class="avatar-container"
    [class.candidate]="type === 'candidate'"
    [class.observer]="type === 'observer'"
    [class.moderator]="type === 'moderator'"
    [class.inactive]="inactive === true"
    [class.white]="white === true"
    [class.avatar]="user.avatar"
    [class.pointer]="pointer === true"
    [class.me]="isMe === true"
    [class.group-moderator]="groupModerator === true"
    [style.background-image]="(user.avatar) ? 'url(' + user.avatar + ')' : ''"
    [pTooltip]="getTooltipName()"
    [tooltipPosition]="tooltipPosition"
  >
    <p [class.busy]="user.busy === true">
      <ng-container *ngIf="isMe"><fa-icon [icon]="faUserTie"></fa-icon></ng-container>
      <ng-container *ngIf="!isMe">{{ user?.initials }}</ng-container>
    </p>
    <ng-container *ngIf="(type === 'candidate' || type === 'observer') && showStatus === true">
      <span *ngIf="!user?.isOnline()" class="is-offline"><i class="pi pi-link" [pTooltip]="t('common.labels.user_offline')" tooltipPosition="right"></i></span>
      <span *ngIf="user?.isBusy()" class="is-busy"><i class="pi pi-play"></i></span>
    </ng-container>
  </div>
</ng-container>
